import React from 'react'
import { Box, Card, CardActions, CardContent, SxProps, Theme } from '@mui/material'

export type AiCardAccent = 'buy' | 'sell' | 'neutral' | 'modify' | 'cancel' | 'live'

type Props = {
    accent?: AiCardAccent
    children: React.ReactNode
    actions?: React.ReactNode
    sx?: SxProps<Theme>
}

function accentColor(accent: AiCardAccent, theme: Theme): string {
    switch (accent) {
        case 'buy':
            return theme.palette.buy.main
        case 'sell':
            return theme.palette.sell.main
        case 'modify':
            return theme.palette.warning.main
        case 'live':
            return theme.palette.error.main
        case 'cancel':
            return theme.palette.text.disabled
        default:
            return theme.palette.divider
    }
}

export default function AiCard({ accent = 'neutral', children, actions, sx }: Props) {
    return (
        <Card
            variant="outlined"
            sx={{
                mt: 1.25,
                overflow: 'visible',
                borderLeftWidth: 3,
                borderLeftStyle: 'solid',
                borderLeftColor: (theme) => accentColor(accent, theme),
                ...sx,
            }}
        >
            <CardContent sx={{ pb: actions ? 1 : 1.5, '&:last-child': { pb: actions ? 1 : 1.5 } }}>
                {children}
            </CardContent>
            {actions ? <CardActions sx={{ px: 2, pt: 0, pb: 1.5, flexWrap: 'wrap', gap: 1 }}>{actions}</CardActions> : null}
        </Card>
    )
}

export function AiCardDivider() {
    return <Box sx={{ borderTop: 1, borderColor: 'divider', my: 1.25 }} />
}
